/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResolveSmsTemplateRequest
 */
export interface ResolveSmsTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof ResolveSmsTemplateRequest
     */
    clientId: string;
    /**
     * 
     * @type {Date}
     * @memberof ResolveSmsTemplateRequest
     */
    appointment?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ResolveSmsTemplateRequest
     */
    previousAppointment?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ResolveSmsTemplateRequest
     */
    newAppointment?: Date | null;
}

/**
 * Check if a given object implements the ResolveSmsTemplateRequest interface.
 */
export function instanceOfResolveSmsTemplateRequest(value: object): value is ResolveSmsTemplateRequest {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function ResolveSmsTemplateRequestFromJSON(json: any): ResolveSmsTemplateRequest {
    return ResolveSmsTemplateRequestFromJSONTyped(json, false);
}

export function ResolveSmsTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveSmsTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'appointment': json['appointment'] == null ? undefined : (new Date(json['appointment'])),
        'previousAppointment': json['previousAppointment'] == null ? undefined : (new Date(json['previousAppointment'])),
        'newAppointment': json['newAppointment'] == null ? undefined : (new Date(json['newAppointment'])),
    };
}

export function ResolveSmsTemplateRequestToJSON(json: any): ResolveSmsTemplateRequest {
    return ResolveSmsTemplateRequestToJSONTyped(json, false);
}

export function ResolveSmsTemplateRequestToJSONTyped(value?: ResolveSmsTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'appointment': value['appointment'] == null ? value['appointment'] : value['appointment'].toISOString(),
        'previousAppointment': value['previousAppointment'] == null ? value['previousAppointment'] : value['previousAppointment'].toISOString(),
        'newAppointment': value['newAppointment'] == null ? value['newAppointment'] : value['newAppointment'].toISOString(),
    };
}

